import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  EVENT_PARTNER_CREATE_REQUEST,
  EVENT_PARTNER_DETAILS_REQUEST,
  EVENT_PARTNER_LIST_REQUEST,
  EVENT_PARTNER_REWARD_LIST_REQUEST,
  EVENT_PARTNER_UPDATE_REQUEST,
} from '../../constants/event/eventPartnerConstants';
import {
  EventsControllerDtoEventInvitationPartnerCreateRequest,
  EventsControllerDtoEventInvitationPartnerDetailRequest,
  EventsControllerDtoEventInvitationPartnerListRequest, EventsControllerDtoEventInvitationPartnerRewardListRequest,
  EventsControllerDtoEventInvitationPartnerUpdateRequest,
  PerplayEventsApi
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import BaseResponse from '../../models/src/model/BaseResponse';
import EventsControllerDtoEventInvitationPartnerRewardListResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationPartnerRewardListResponse';
import EventsControllerDtoEventInvitationPartnerDetailResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationPartnerDetailResponse';
import EventsControllerDtoEventInvitationPartnerListResponse
  from '../../models/src/model/EventsControllerDtoEventInvitationPartnerListResponse';
const api = new PerplayEventsApi(config.API_CLIENT);

function* eventPartnerCreateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationPartnerCreateRequest();
    requestData.partnerEmail = payload.partnerEmail;
    requestData.invCode = payload.invCode;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationPartnerCreatePost({ eventsControllerDtoEventInvitationPartnerCreateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* eventPartnerUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationPartnerUpdateRequest();
    requestData.partnerAccountNo = payload.partnerAccountNo;
    requestData.invCode = payload.invCode;
    requestData.enabled = payload.enabled;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationPartnerUpdatePost({ eventsControllerDtoEventInvitationPartnerUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* eventPartnerListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationPartnerListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationPartnerListPost({ eventsControllerDtoEventInvitationPartnerListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationPartnerListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* eventPartnerDetailsRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationPartnerDetailRequest();
    requestData.accountNo = payload.accountNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationPartnerDetailPost({ eventsControllerDtoEventInvitationPartnerDetailRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationPartnerDetailResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* eventPartnerRewardListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new EventsControllerDtoEventInvitationPartnerRewardListRequest();
    requestData.invNo = payload.invNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayEventsEventInvitationPartnerRewardListPost({ eventsControllerDtoEventInvitationPartnerRewardListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventInvitationPartnerRewardListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* eventPartnerRootSaga() {
  yield all([
    takeEvery(EVENT_PARTNER_CREATE_REQUEST, eventPartnerCreateRequestSaga),
    takeEvery(EVENT_PARTNER_UPDATE_REQUEST, eventPartnerUpdateRequestSaga),
    takeEvery(EVENT_PARTNER_LIST_REQUEST, eventPartnerListRequestSaga),
    takeEvery(EVENT_PARTNER_DETAILS_REQUEST, eventPartnerDetailsRequestSaga),
    takeEvery(EVENT_PARTNER_REWARD_LIST_REQUEST, eventPartnerRewardListRequestSaga),
  ]);
}

const eventPartnerSagas = [
  fork(eventPartnerRootSaga),
];

export default eventPartnerSagas;
